import React, { useEffect } from "react";
import Slider from "react-slick";
import ScreenShot1 from "../Assets/img/screenshot/screenshot-1.png";
import ScreenShot2 from "../Assets/img/screenshot/screenshot-2.png";
import ScreenShot3 from "../Assets/img/screenshot/screenshot-3.png";
import ScreenShot4 from "../Assets/img/screenshot/screenshot-4.png";
import ScreenShot5 from "../Assets/img/screenshot/screenshot-5.png";
import ScreenShot6 from "../Assets/img/screenshot/screenshot-6.png";
import ScreenShot7 from "../Assets/img/screenshot/screenshot-7.png";
import ScreenShot8 from "../Assets/img/screenshot/screenshot-8.png";
import ScreenShot9 from "../Assets/img/screenshot/screenshot-9.png";
import ScreenShot10 from "../Assets/img/screenshot/screenshot-10.png";
import ScreenShot11 from "../Assets/img/screenshot/screenshot-11.png";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import "photoswipe/style.css";

const ScreenShootMain = [
  {
    id: "item1",
    img: ScreenShot1,
    title: "Informative Dashboard",
  },
  {
    id: "item2",
    img: ScreenShot2,
    title: "Dynamic Client List",
  },
  {
    id: "item3",
    img: ScreenShot3,
    title: "Reliable Billing List",
  },
  {
    id: "item4",
    img: ScreenShot4,
    title: "Support & Ticketing",
  },
  {
    id: "item5",
    img: ScreenShot5,
    title: "Bandwidth Sales",
  },
  {
    id: "item6",
    img: ScreenShot6,
    title: "BTRC Report",
  },
  {
    id: "item7",
    img: ScreenShot7,
    title: "Cash Book (Accounts)",
  },
  {
    id: "item8",
    img: ScreenShot8,
    title: "Daily Bill Collection",
  },
  {
    id: "item9",
    img: ScreenShot9,
    title: "Mac Reseller Panel",
  },
  {
    id: "item10",
    img: ScreenShot10,
    title: "Online Client Monitoring",
  },
  {
    id: "item11",
    img: ScreenShot11,
    title: "Payslip",
  },
];

const ScreenShootSlider = (props) => {
  useEffect(() => {
    let lightbox = new PhotoSwipeLightbox({
      gallery: "#" + props.galleryID,
      children: "a",
      pswpModule: () => import("photoswipe"),
    });
    lightbox.init();

    return () => {
      lightbox.destroy();
      lightbox = null;
    };
  }, []);

  const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "30px",
    slidesToShow: 3,
    speed: 500,
    autoplay: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <>
      <section className="screenshot-area">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 col-12">
              <div className="section-title">
                <h3>Software Screenshot</h3>
                {/* <p>
                  Semper suscipit ornare egestas augue. Ut est etiam mauris at
                  lorem faucibus lorem arcu. Tellus sed gravida pharetra nulla.
                </p> */}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="screenshot-slider">
                <Slider {...settings}>
                  {ScreenShootMain.map((SingleSlider) => (
                    <div
                      className="single-screenshot"
                      key={SingleSlider.id}
                      id={props.galleryID}
                    >
                      <div className="screen-body">
                        <img src={SingleSlider.img} alt="#" />
                        {props.images.map((image, index) => (
                          <a
                            href={image.largeURL}
                            data-pswp-width={image.width}
                            data-pswp-height={image.height}
                            key={props.galleryID + "-" + index}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <div className="p-button">
                              <i className="fa fa-image"></i>
                            </div>
                          </a>
                        ))}
                      </div>
                      <div className="screenshot-content-top">
                        <div className="screenshot-content">
                          <h3 className="scr-title">{SingleSlider.title}</h3>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ScreenShootSlider;
